import constants from '../constants/index';

const StudentCohortActions  = {
  changeStudentCohortFilter: function(id, selected) {
    return {
      type: constants.CHANGE_STUDENT_COHORT_FILTER,
      payload: {
        id: id,
        selected: selected
      }
    };
  }
};

export default StudentCohortActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/student_cohort_actions.js
 **/